const console = window.console,
    hasConsole =
        console !== undefined &&
        console !== null &&
        typeof console.log.bind === "function"
            ? true
            : false,
    noop = function () {};

export default {
    error: hasConsole ? console.error.bind(console) : noop,
    warn: hasConsole ? console.warn.bind(console) : noop,
    info: hasConsole ? console.info.bind(console) : noop,
    debug: hasConsole ? console.log.bind(console) : noop,
    trace: hasConsole ? console.log.bind(console, "TRACE: ") : noop,
};
